import React from 'react';

/*
 *  @Description:   Stateless component that renders a User Icon.
 */

const User = ( props ) => {

    return (<g id="path">
            <circle cx="12" cy="10" r="7"/>
            <path d="m6.85 16c-4.66 3.5-4.48 5-2.76 5h15.8c1.72 0 1.9-1.48-2.76-5"/>
        </g>
    )

};


export default User;

